export default __webpack_public_path__ + "img/m4.asset.7dcedc63.png";